export const PAYMENT_CHECKOUT_REQUEST = 'PAYMENT_CHECKOUT_REQUEST'
export const PAYMENT_CHECKOUT_SUCCESS = 'PAYMENT_CHECKOUT_SUCCESS'
export const PAYMENT_CHECKOUT_FALIURE = 'PAYMENT_CHECKOUT_FALIURE'
